.paymentMethod {
  display: var(--haus-paymentMethod__form__display, flex);
  flex-direction: var(--haus-paymentMethod__form__flex-direction, column);
  gap: var(--haus-paymentMethod__form__gap, 16px);
}

.form {
  display: var(--haus-paymentMethod__form__display, flex);
  flex-direction: var(--haus-paymentMethod__form__flex-direction, column);
  gap: var(--haus-paymentMethod__form__gap, 16px);
}

.required {
  color: var(--haus-paymentMethod__required__color, var(--haus-color-error, #dc3545));
}

.error {
  color: var(--haus-paymentMethod__error__color, var(--haus-color-error, #dc3545));
  font-size: var(--haus-paymentMethod__error__font-size, 0.875rem);
  margin-top: var(--haus-paymentMethod__error__margin-top, -8px);
}

.buttonWrapper {
  margin-top: var(--haus-paymentMethod__buttonWrapper__margin-top, 0);
}
